export default "__VITE_ASSET__DTFT4hP$__"